import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React, { useEffect, useState } from "react";

//Import Icons
import FeatherIcon from "feather-icons-react";

import { Alert } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link, useHistory } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Social Media Imports
import { GoogleLogin } from "react-google-login";
// import TwitterLogin from "react-twitter-auth"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// actions
import { loginUser, socialLogin } from "../../store/actions";

//Import config
import { facebook, google } from "../../config";
import AuthLayout from "../../components/authenticate/AuthLayout";

const Login = (props) => {
    const dispatch = useDispatch();

    const { error } = useSelector((state) => ({
        error: state.Login.error,
    }));

    // handleValidSubmit
    const handleValidSubmit = (event, values) => {
        dispatch(loginUser(values, props.history));
    };

    const signIn = (res, type) => {
        if (type === "google" && res) {
            const postData = {
                name: res.profileObj.name,
                email: res.profileObj.email,
                token: res.tokenObj.access_token,
                idToken: res.tokenId,
            };
            dispatch(socialLogin(postData, props.history, type));
        } else if (type === "facebook" && res) {
            const postData = {
                name: res.name,
                email: res.email,
                token: res.accessToken,
                idToken: res.tokenId,
            };
            dispatch(socialLogin(postData, props.history, type));
        }
    };

    //handleGoogleLoginResponse
    const googleResponse = (response) => {
        signIn(response, "google");
    };

    //handleTwitterLoginResponse
    // const twitterResponse = e => {}

    //handleFacebookLoginResponse
    const facebookResponse = (response) => {
        signIn(response, "facebook");
    };

    const [email, setemail] = useState("");
    const [password, setpassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [invalidStatus, setinvalidStatus] = useState(false);

    const [loginBtnStatus, setloginBtnStatus] = useState(true)

    let history = useHistory();
    function handleClick() {
        history.push("/login");
    }

    const token = localStorage.getItem("token");
    useEffect(() => {
    }, [])
    async function loginUser(event) {
        // event.preventDefault();
        // console.log("email-passs",email,password)
        // console.log(`${process.env.REACT_APP_DEFAULTPATH}`);
        const response = await fetch(`${process.env.REACT_APP_DEFAULTPATH}login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email,
                password,
            }),
        });
        const data = await response.json();
        if (data.status === "ok") {
            console.log("data of login", data);
            localStorage.setItem("token", data.token);
            localStorage.setItem("userID", data.userID);
            localStorage.setItem("orgID", data.orgID);
            localStorage.setItem("authUser", false)
            // alert("Login successfull ");
            window.location.href = "/dashboard";
        } else {
            setinvalidStatus(true);
            // alert("please Check ur email pass combo ");
            // window.location.href = "/login";
        }
        // console.log("data",data);
        // console.log("name",name);
    }
    return (
        <React.Fragment>
            <MetaTags>
                <title>Login | Glogix</title>
            </MetaTags>

            <AuthLayout
                footer={
                    <>
                        Don't have an account yet ? <Link to="/register">Register</Link>
                    </>
                }
            >
                <div className="gx-auth-card">
                    <div className="gx-auth-title">
                        <h4>Welcome</h4>
                        <p>Login to continue to the Glogix Platform.</p>
                    </div>

                    {invalidStatus && (
                        <Alert color="danger" className="d-flex align-items-center py-2">
                            <FeatherIcon icon="alert-circle" size={16} className="me-2 flex-shrink-0" />
                            Invalid email or password
                        </Alert>
                    )}

                    <AvForm className="custom-form" onValidSubmit={loginUser}>
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        <div className="mb-3">
                            <AvField
                                name="email"
                                label="Email"
                                value={email}
                                className="form-control"
                                placeholder="Enter email"
                                type="email"
                                required
                                onChange={(e) => setemail(e.target.value)}
                            />
                        </div>

                        <div className="mb-4">
                            <label className="form-label">Password</label>
                            <div className="gx-password">
                                <AvField
                                    name="password"
                                    value={password}
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    required
                                    placeholder="Enter Password"
                                    onChange={(e) => {
                                        if (email != " " && password != " ") {
                                            setloginBtnStatus(false)
                                        }
                                        setpassword(e.target.value)
                                    }}
                                />
                                <button
                                    type="button"
                                    className="gx-password-toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                >
                                    <FeatherIcon icon={showPassword ? "eye-off" : "eye"} size={16} />
                                </button>
                            </div>
                        </div>

                        <button
                            className="btn btn-primary w-100"
                            type="submit"
                            disabled={loginBtnStatus}
                        >
                            Login
                            <FeatherIcon icon="arrow-right" size={16} className="ms-2" />
                        </button>

                        <Link to="/admin-login" id="login-as-admin-btn" className="gx-btn-admin mt-3">
                            <FeatherIcon icon="shield" size={15} />
                            Login as Admin
                        </Link>
                    </AvForm>
                </div>
            </AuthLayout>
        </React.Fragment>
    );
};

export default withRouter(Login);

Login.propTypes = {
    history: PropTypes.object,
};
